import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames, LocalStorageItems } from '../../../models/Common';
import { ApiError } from '../../../models/ApiError';
import { userInfoApi } from '../../../services/apiServices/user/userInfo';
import { useCustomSnackbar } from '../../../hooks/useCustomEnqueueSnackbar';
import { getErrorMessage } from '../../../utils';

const EmailConfirmed = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const { search } = useLocation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const email = localStorage.getItem(LocalStorageItems.Email);
  const [confirmEmailApi] = userInfoApi.useConfirmEmailMutation();
  const queryParams = new URLSearchParams(search);

  const handleClick = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  const confirmEmail = async (code: string) => {
    try {
      await confirmEmailApi({ code }).unwrap();
    } catch (err: unknown) {
      const error = err as ApiError;
      if (error.status !== 400) {
        const message = getErrorMessage(err);
        customEnqueueSnackbar(message, 'error');
      } else {
        history.push({
          pathname: GlobalRouteNames.UnknownError,
          state: { message: '404.invalidLink' },
        });
      }
    }
  };

  useEffect(() => {
    if (queryParams.has('code')) {
      confirmEmail(String(queryParams.get('code'))).then(() => {
        setIsLoading(false);
      });
    } else {
      history.push({
        pathname: GlobalRouteNames.UnknownError,
        state: { message: '404.invalidLink' },
      });
    }
    return () => {
      localStorage.removeItem(LocalStorageItems.Email);
    };
  }, []);

  return (
    <div className="success-container">
      <h1 className={isLoading ? 'skeleton' : 'skeleton--disabled'}>{t('success.emailConfirmed')}</h1>
      {email && <p className={isLoading ? 'skeleton' : 'skeleton--disabled'}>{email}</p>}
      <CustomMUIButton
        label={t('buttons.toMain')}
        handleClick={handleClick}
        className={ButtonClassNames.PrimaryFulfilled}
        isBold
        isDisabled={isLoading}
      />
    </div>
  );
};

export default EmailConfirmed;
